<template>
  <div class="">
    <b-button variant="secondary" @click="submit" pill>
      <b-icon icon="download" class="ml-1"></b-icon>
      Excel خروجی
    </b-button>
  </div>
</template>

<script>
import {queryBuilder} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/QueryFilter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "DataExport",
  props: {
    dataType: {
      default: 'product', // for now support: product and menu
    }
  },
  methods: {
    toast,
    submit() {
      let form = {
        model_name: this.dataType,
        query: ''
      }
      if (this.dataType == 'product') {
        form.query = queryBuilder(this.$store.getters['Product/getFilters'])
      }
      this.$store.dispatch('DataExport/getData', form).then(response => {
        // ساخت BOM مجدد برای اطمینان
        const bom = '\uFEFF'; // BOM برای UTF-8

        // خواندن فایل به صورت text
        const reader = new FileReader();
        reader.onload = () => {
          // اضافه کردن BOM به متن
          const csvWithBom = bom + reader.result;

          // ساخت فایل Blob جدید با BOM
          const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);

          // ساخت لینک برای دانلود
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'export.csv');
          document.body.appendChild(link);
          link.click();
          link.remove();
        };
        reader.readAsText(response.data);
      }).catch((error) => {
        this.toast('خطا در دانلود فایل','خطا در دانلود فایل','error');
      });


    }
  }
}
</script>

<style scoped>

</style>